import React from 'react';
import { Section } from './ui/Section';
import { Timer, UserX, UserCheck } from 'lucide-react';
export function RealProblem() {
  return <Section className="bg-[#0F1525]" data-id="element-277">
      <div className="max-w-4xl mx-auto" data-id="element-278">
        <div className="text-center mb-16" data-id="element-279">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-balance" data-id="element-280">
            El Problema No Es Tu Talento. <br data-id="element-281" />
            <span className="text-brand-accent" data-id="element-282">Es Tu Presencia Digital.</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-283">Seamos honestos.</p>
        </div>

        <div className="bg-brand-surface border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-284">
          {/* Decorative background element */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-accent/10 rounded-full blur-3xl" data-id="element-285"></div>

          <div className="relative z-10" data-id="element-286">
            <div className="flex items-center gap-4 mb-8" data-id="element-287">
              <div className="p-3 bg-brand-dark rounded-lg border border-white/10" data-id="element-288">
                <Timer className="w-6 h-6 text-brand-accent" data-id="element-289" />
              </div>
              <p className="text-lg text-slate-300" data-id="element-290">
                En el mundo de hoy, antes de contratarte, tus clientes
                potenciales te buscan en Google. Revisan tu web.
              </p>
            </div>

            <div className="mb-10" data-id="element-291">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-292">
                En menos de{' '}
                <span className="text-brand-accent" data-id="element-293">7 segundos</span> toman una
                decisión inconsciente:
              </h3>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-294">
                <div className="bg-emerald-500/10 border border-emerald-500/20 p-6 rounded-xl relative" data-id="element-295">
                  <UserCheck className="absolute top-4 right-4 w-6 h-6 text-emerald-500/50" data-id="element-296" />
                  <p className="text-lg font-medium text-emerald-400 italic" data-id="element-297">
                    "Este es un profesional que puede ayudarme"
                  </p>
                </div>

                <div className="bg-red-500/10 border border-red-500/20 p-6 rounded-xl relative" data-id="element-298">
                  <UserX className="absolute top-4 right-4 w-6 h-6 text-red-500/50" data-id="element-299" />
                  <p className="text-lg font-medium text-red-400 italic" data-id="element-300">
                    "No parece muy serio. Voy a seguir buscando."
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4 text-lg text-slate-300 border-t border-white/10 pt-8" data-id="element-301">
              <p data-id="element-302">
                No importa cuánto talento tengas. No importa cuántos años de
                experiencia acumules.
              </p>
              <p className="font-semibold text-white text-xl" data-id="element-303">
                Si tu presencia digital no transmite autoridad, estás perdiendo
                la venta antes de que empiece.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}